var _path, _path2, _path3, _path4, _use, _use2, _use3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgGg = function SvgGg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 480,
    width: 640,
    viewBox: "0 0 640 480"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h640v480H0z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M256 0h128v480H256z",
    fill: "#e8112d"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 176h640v128H0z",
    fill: "#e8112d"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M109.991 286.667l23.342-23.343h210.01v-46.666h-210.01l-23.342-23.325z",
    fill: "#f9dd16"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "rotate(90 320 240)",
    height: 24,
    width: 36
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "rotate(-90 320 240)",
    height: 24,
    width: 36
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "rotate(180 320 240)",
    height: 24,
    width: 36
  })));
};
export default __webpack_public_path__ + "assets/852fdd82515c7372a678b41e67c3f764.svg";
export { SvgGg as ReactComponent };


// WEBPACK FOOTER //
// ./assets/images/flags/4x3/gg.svg